import clsx from "clsx";
import { Timer } from "lucide-react";

type FastFillingLabelProps = {
  className?: string;
};

const FastFillingLabel = ({ className }: FastFillingLabelProps) => {
  return (
    <span
      className={clsx(
        "flex gap-0.5 items-center italic text-xs justify-center text-error-main",
        className
      )}
    >
      <span className="relative inline-flex items-center">
        {/* Speed lines */}
        <span className="absolute left-0 flex flex-col items-end justify-between h-3 -translate-x-2.5">
          <span className="block w-1 h-0.5 bg-error-main rounded-full"></span>
          <span className="block w-2 h-0.5 bg-error-main rounded-full"></span>
          <span className="block w-3 h-0.5 bg-error-main rounded-full"></span>
        </span>
        <Timer size={20} />
      </span>
      <span className="mt-1 tracking-wide">Seats filling fast</span>
    </span>
  );
};

export default FastFillingLabel;
